var POPUP_SECTION_TYPES = ['title', 'icon', 'content', 'actions'];

export { POPUP_SECTION_TYPES };
